
export class GenericAttachmentUploadProperties<T> {
    private _selectedFileList: [] = [];//FileList=null!;
    private _selectedAbsEntry: any;
    private _selectedAttachedList: [] = [];
    private _selectedAttachedListData: [] = [];
    private _selectedEventFile: FileList = null!;

    set setSelectedFileList(event: any) {
        this._selectedFileList = event;//event.target.files;
    }
    get getSelectedFileList(): any {
        return this._selectedFileList;
    }
    set setAbsEntry(event: any) {
        this._selectedAbsEntry = event;//event.target.files;
    }
    get getAbsEntry(): any {
        return this._selectedAbsEntry;
    }

    set setAttactmentList(event: any) {
        this._selectedAttachedList = event;//event.target.files;
    }
    get getAttactmentList(): any {
        return this._selectedAttachedList;
    }
    set setAttactmentListData(event: any) {
        this._selectedAttachedListData = event;//event.target.files;
    }
    get getAttactmentListData(): any {
        return this._selectedAttachedListData;
    }
}